import styled from "styled-components";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";

import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import Dropdown from "components/forms/Dropdown";
import RollingBox from "components/other/RollingBox";
import DropdownSelection from "components/forms/DropdownSelection";
import SelectionItem from "components/forms/SelectionItem";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import InputWithLabel from "components/forms/InputWithLabel";
import InputText from "components/forms/InputText";
import Tip from "components/other/Tip";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";

import bankIcon from "assets/img/icons/icons8-bank.png";
import bitcoinIcon from "assets/img/icons/icons8-bitcoin.svg";
import skrillIcon from "assets/img/icons/icons8-skrill.svg";
import tetherIcon from "assets/img/icons/icons8-tether.svg";
import bulbIcon from "assets/img/icons/tip-bulb.svg";
import tronIcon from "assets/img/icons/tron-icon.svg";
import ethereumIcon from "assets/img/icons/ethereum-icon.svg";
import bscIcon from "assets/img/icons/bsc-icon.svg";
import polygonIcon from "assets/img/icons/polygon-icon.svg";
import warningIcon from "assets/img/icons/warning-triangle-icon.svg";
import faucetpayIcon from "assets/img/icons/faucetpay-icon.png";
import usdcIcon from "assets/img/icons/usdc-icon.svg";
import newTabIcon from "assets/img/icons/Expand-Window.svg";
import CountryDropdownSelection from "components/forms/CountryDropdownSelection";

const PayoutSettings = styled.div`
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;
  /* min-height: 360px; */

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TitleText = styled.div`
  margin-top: 6px;
`;

const PaymentMethod = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const SettinsgItemTitle = styled.div`
  width: 100%;
  padding-left: 3px;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};

  display: flex;
  align-items: center;
  gap: 6px;
`;

const DropdownWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 290px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const SettingsItemLine = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};

  @media (max-width: ${globalConstants.switchMobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SettingsItemValue = styled.div`
  padding: 4px 0 4px 3px;
`;

const SettingsItemButtonWrap = styled.div``;

const MethodHidingBox = styled.div`
  margin-top: 10px;
  padding-bottom: 15px;
  /* min-height: 165px; */

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const PaymentMethodSelectionWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const MethodSelectionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const MethodSelectionIcon = styled.div`
  width: 26px;
  min-width: 26px;
  height: 26px;
  max-height: 26px;
`;

const MethodSelectedText = styled.div``;

const MethodSelectionText = styled.div`
  font-family: "Arial", sans-serif;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

const PaymentMethodDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const MethodDetailsHidingBox = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
  padding-bottom: 10px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const MethodDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media (max-width: ${globalConstants.switchMobile}) {
    max-width: 100%;
  }
`;

const MethodDetailsItem = styled.div`
  display: flex;

  @media (max-width: 750px) {
    max-width: 100%;
    flex-direction: column;
  }
`;

const MethodDetailsLabel = styled.div`
  padding: 4px 0 4px 3px;

  white-space: nowrap;
`;

const MethodDetailsValue = styled.div`
  width: 100%;
  max-width: 260px;
  padding: 4px 0 4px 3px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 750px) {
    padding: 0px 0 4px 3px;
  }

  @media (max-width: ${globalConstants.switchMobile}) {
    max-width: 100%;
  }
`;

const TipBox = styled.div`
  /* max-width: 315px; */
  padding: ${css.BOX_PADDING_SECONDARY};
  width: 100%;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  flex: 0.5;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TipWrap = styled.div`
  display: flex;
  align-items: center;
`;

const TipIcon = styled.div`
  width: 22px;
  min-width: 22px;
  height: 22px;
`;

const TipText = styled.div`
  padding-left: 12px;

  flex: 1;
`;

const MinPayoutInfo = styled.div`
  margin-top: 0px;

  font-size: 13px;
  color: ${css.TEXT_GREY};
  line-height: 125%;
`;

const ExternalLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 6px;

  text-decoration: none;
`;

const ExternalLinkText = styled.div`
  color: ${css.LIGHT_BLUE};
  font-size: 13px;
`;

const ExternalLinkIcon = styled.div`
  width: 9px;
  min-width: 9px;
`;

const VerificationCodeInfo = styled.div`
  margin-top: 6px;
`;

const VerificationCodeError = styled.div`
  margin-bottom: 6px;

  color: ${css.NEGATIVE_RED};
  font-weight: 500;
`;

const InputWithButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const WarningBox = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN};
  margin-bottom: ${css.VERTICAL_BOX_MARGIN};
  width: 100%;
  padding: ${css.BOX_PADDING_SECONDARY};
  margin-top: 8px;
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  gap: 15px;
`;

const WarningBoxIcon = styled.div`
  width: 22px;
  min-width: 22px;
  height: 22px;
`;

const WarningBoxText = styled.div`
  line-height: 125%;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const WarningBoxTextParagraph = styled.div``;

export default ({
  data,
  changePaymentMethodForm,
  changePaymentMethodFormToggle,
  methodSelectionOpened,
  toggleMethodSelection,
  changeMethod,
  onMethodSelect,
  methodSelected,
  warnings,
  loadingChangeMethod,
  methodDetails,
  handleDetailsInputChange,
  methodDetailsFormToggle,
  methodDetailsForm,
  updateMethodDetails,
  loadingUpdateMethodDetails,
  toggleUsdtNetworkSelection,
  usdtNetworkSelectionOpened,
  onUsdtNetworkSelect,
  onFaucetpayCurrencySelect,
  toggleFaucetpayCurrencySelection,
  faucetpayCurrencySelectionOpened,
  handleBankAccountCountryChange,
  handleAccountCountryChange,
  verificationCodeRequested,
  getVerificationCode,
  verificationCode,
  handleVerificationCodeChange,
  verificationCodeError,
  verificationCodeSentCounter,
}) => {
  if (!data.payoutSettingsData) {
    return (
      <LoadingBox>
        <BoxLoadingSpinner />
      </LoadingBox>
    );
  }

  const { created_at, payment_method, payment_method_details } =
    data.payoutSettingsData;
  const {
    bank_account_number,
    bank_routing_number,
    bank_iban,
    bank_swift,
    bank_account_name,
    bank_street,
    bank_city,
    bank_zip,
    bank_country,
    skrill_email,
    bitcoin_address,
    account_full_name,
    account_street,
    account_city,
    account_zip,
    account_country,
    usdt_address,
    usdt_network,
    faucetpay_username,
    faucetpay_currency,
  } = payment_method_details || {};

  const methodDropdownRef = useRef();
  const methodSelectionRef = useRef();
  const formButtonRef = useRef();
  const usdtNetworkDropdownRef = useRef();
  const usdtNetworkSelectionRef = useRef();
  const faucetpayCurrencyDropdownRef = useRef();
  const faucetpayCurrencySelectionRef = useRef();

  function useMethodSelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !methodDropdownRef.current.contains(event.target) &&
          !formButtonRef.current.contains(event.target)
        ) {
          toggleMethodSelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useMethodSelectionOutsideClick(methodSelectionRef);

  function useUsdtNetworkSelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !usdtNetworkDropdownRef.current.contains(event.target)
        ) {
          toggleUsdtNetworkSelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useUsdtNetworkSelectionOutsideClick(usdtNetworkSelectionRef);

  function useFaucetpayCurrencySelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !faucetpayCurrencyDropdownRef.current.contains(event.target)
        ) {
          toggleFaucetpayCurrencySelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useFaucetpayCurrencySelectionOutsideClick(faucetpayCurrencySelectionRef);

  const includeSkrill = false;
  const includeFaucetpay = false;

  const methodOptions = {
    bank: {
      name: "Bank Transfer",
      nameWithAmount: "Bank Transfer (min. $50)",
      icon: bankIcon,
    },
    skrill: {
      name: "Skrill",
      nameWithAmount: "Skrill (min. $20)",
      icon: skrillIcon,
    },
    bitcoin: {
      name: "Bitcoin",
      nameWithAmount: "Bitcoin (min. $10)",
      icon: bitcoinIcon,
    },
    usdt: {
      name: "USDT",
      nameWithAmount: "USDT (min. $10)",
      icon: tetherIcon,
    },
    faucetpay: {
      name: "FaucetPay",
      nameWithAmount: "FaucetPay (min. $2, max. $20)",
      icon: faucetpayIcon,
    },
  };

  let minPayoutInfo =
    "* The minimum payout amount for a bank transfer is $50 USD. For Skrill, the minimum is $20 USD. For Bitcoin, and USDT payouts, the minimum is $10 USD. For FaucetPay, the minimum is $2 USD and the maximum is $20 USD.";

  if (!includeSkrill) {
    delete methodOptions.skrill;

    minPayoutInfo =
      "* The minimum payout amount for a bank transfer is $50 USD. For Bitcoin, and USDT payouts, the minimum is $10 USD. For FaucetPay, the minimum is $2 USD and the maximum is $20 USD.";
  }

  let methodOptionsList = [];

  Object.keys(methodOptions).forEach((method) => {
    if (method === "faucetpay" && !includeFaucetpay) {
      minPayoutInfo =
        "* The minimum payout amount for a bank transfer is $50 USD. For Bitcoin, and USDT payouts, the minimum is $10 USD.";

      return;
    }

    methodOptionsList.push(
      <SelectionItem
        onClick={() => onMethodSelect(method)}
        key={methodOptions[method].name}
      >
        <MethodSelectionItem>
          <MethodSelectionIcon>
            <img
              src={methodOptions[method].icon}
              alt={methodOptions[method].nameWithAmount}
              style={{ width: "100%", maxHeight: "100%" }}
            />
          </MethodSelectionIcon>
          <MethodSelectionText>
            {methodOptions[method].nameWithAmount}
          </MethodSelectionText>
        </MethodSelectionItem>
      </SelectionItem>,
    );
  });

  const usdtNetworkOptions = {
    ethereum: {
      name: "Ethereum",
      icon: ethereumIcon,
    },
    tron: {
      name: "Tron",
      icon: tronIcon,
    },
    bsc: {
      name: "BSC",
      icon: bscIcon,
    },
    polygon: {
      name: "Polygon",
      icon: polygonIcon,
    },
  };

  let usdtNetworkOptionsList = [];

  Object.keys(usdtNetworkOptions).forEach((option) => {
    usdtNetworkOptionsList.push(
      <SelectionItem
        onClick={() => {
          onUsdtNetworkSelect(option);
        }}
        key={usdtNetworkOptions[option].name}
      >
        <MethodSelectionItem>
          <MethodSelectionIcon>
            <img
              src={usdtNetworkOptions[option].icon}
              alt={usdtNetworkOptions[option].name}
              style={{ width: "100%", maxHeight: "100%" }}
            />
          </MethodSelectionIcon>
          <MethodSelectionText>
            {usdtNetworkOptions[option].name}
          </MethodSelectionText>
        </MethodSelectionItem>
      </SelectionItem>,
    );
  });

  const faucetpayCurrencyOptions = {
    usdttrc20: {
      name: "USDT TRC20",
      icon: tetherIcon,
    },
    usdc: {
      name: "USDC",
      icon: usdcIcon,
    },
  };

  let faucetpayCurrencyOptionsList = [];

  Object.keys(faucetpayCurrencyOptions).forEach((option) => {
    faucetpayCurrencyOptionsList.push(
      <SelectionItem
        onClick={() => {
          onFaucetpayCurrencySelect(option);
        }}
        key={faucetpayCurrencyOptions[option].name}
      >
        <MethodSelectionItem>
          <MethodSelectionIcon>
            <img
              src={faucetpayCurrencyOptions[option].icon}
              alt={faucetpayCurrencyOptions[option].name}
              style={{ width: "100%", maxHeight: "100%" }}
            />
          </MethodSelectionIcon>
          <MethodSelectionText>
            {faucetpayCurrencyOptions[option].name}
          </MethodSelectionText>
        </MethodSelectionItem>
      </SelectionItem>,
    );
  });

  const bankDetailsNotProvided =
    !bank_account_number &&
    !bank_routing_number &&
    !bank_iban &&
    !bank_swift &&
    !bank_account_name &&
    !bank_street &&
    !bank_city &&
    !bank_zip &&
    !bank_country;

  let resendButtonText = "Resend";

  if (verificationCodeSentCounter > 0)
    resendButtonText += ` (${verificationCodeSentCounter})`;

  return (
    <PayoutSettings>
      <TitleText>
        Choose how you want to receive payouts for cash bonuses and referral
        contest prizes.
      </TitleText>
      <RollingBox>
        <PaymentMethod>
          <SettinsgItemTitle>
            Payment Method
            <Tip
              tipId="payoutMinimum"
              tip="If the minimum payout amount for the selected method is not reached by the end of the month, the sum will be carried over to the next month."
            />
          </SettinsgItemTitle>
          <SettingsItemLine>
            <SettingsItemValue>
              {!payment_method && "Not selected"}
              {payment_method && (
                <PaymentMethodSelectionWrap>
                  <MethodSelectionItem>
                    <MethodSelectionIcon>
                      <img
                        src={methodOptions[payment_method].icon}
                        alt={methodOptions[payment_method].name}
                        style={{ width: "100%", maxHeight: "100%" }}
                      />
                    </MethodSelectionIcon>
                    <MethodSelectedText>
                      {methodOptions[payment_method].name}
                    </MethodSelectedText>
                  </MethodSelectionItem>
                  {payment_method === "faucetpay" && (
                    <ExternalLink
                      to="https://faucetpay.io/?r=6453581"
                      target="_blank"
                    >
                      <ExternalLinkText>
                        Create FaucetPay wallet
                      </ExternalLinkText>
                      <ExternalLinkIcon>
                        <img src={newTabIcon} style={{ width: "100%" }} />
                      </ExternalLinkIcon>
                    </ExternalLink>
                  )}
                </PaymentMethodSelectionWrap>
              )}
            </SettingsItemValue>
            <SettingsItemButtonWrap ref={formButtonRef}>
              <ButtonPrimarySmall onClick={changePaymentMethodFormToggle}>
                {changePaymentMethodForm ? "Close" : "Change Payment Method"}
              </ButtonPrimarySmall>
            </SettingsItemButtonWrap>
          </SettingsItemLine>
          {changePaymentMethodForm && (
            <MethodHidingBox>
              <DropdownWrap>
                <Dropdown
                  onClick={toggleMethodSelection}
                  dropdownRef={methodDropdownRef}
                  warning={warnings.includes("paymentMethod")}
                >
                  {!methodSelected && "Select payment method"}
                  {methodSelected && (
                    <MethodSelectionItem>
                      <MethodSelectionIcon>
                        <img
                          src={methodOptions[methodSelected].icon}
                          alt={methodOptions[methodSelected].name}
                          style={{ width: "100%", maxHeight: "100%" }}
                        />
                      </MethodSelectionIcon>
                      <MethodSelectionText>
                        {methodOptions[methodSelected].name}
                      </MethodSelectionText>
                    </MethodSelectionItem>
                  )}
                </Dropdown>
                {methodSelectionOpened && (
                  <DropdownSelection
                    width="290px"
                    top="48px"
                    selectionRef={methodSelectionRef}
                    maxHeight="220px"
                  >
                    {methodOptionsList}
                  </DropdownSelection>
                )}
                <ButtonWrap>
                  <ButtonPrimary
                    onClick={changeMethod}
                    disabled={loadingChangeMethod}
                  >
                    Save
                  </ButtonPrimary>
                </ButtonWrap>
              </DropdownWrap>
              <MinPayoutInfo>{minPayoutInfo}</MinPayoutInfo>
              <TipBox>
                <TipWrap>
                  <TipIcon>
                    <img src={bulbIcon} alt="Tip" style={{ width: "100%" }} />
                  </TipIcon>
                  <TipText>
                    The payment method set at the end of the month will be used
                    to pay out your balance.
                  </TipText>
                </TipWrap>
              </TipBox>
            </MethodHidingBox>
          )}
        </PaymentMethod>
      </RollingBox>
      {(payment_method === "bitcoin" || payment_method === "usdt") && (
        <TipBox>
          <TipWrap>
            <TipIcon>
              <img src={warningIcon} alt="Tip" style={{ width: "100%" }} />
            </TipIcon>
            <TipText>
              The cryptocurrency transaction network fee will be deducted from
              your payout.
            </TipText>
          </TipWrap>
        </TipBox>
      )}
      {payment_method === "bank" && (
        <RollingBox>
          <PaymentMethodDetails>
            <SettinsgItemTitle>Bank Transfer Details</SettinsgItemTitle>
            <SettingsItemLine>
              <MethodDetails>
                {bankDetailsNotProvided && (
                  <MethodDetailsValue>
                    Banking details not provided
                  </MethodDetailsValue>
                )}
                {bank_account_number && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Bank account #:</MethodDetailsLabel>
                    <MethodDetailsValue>
                      {bank_account_number}
                    </MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_routing_number && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Routing #:</MethodDetailsLabel>
                    <MethodDetailsValue>
                      {bank_routing_number}
                    </MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_iban && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>IBAN: </MethodDetailsLabel>
                    <MethodDetailsValue>{bank_iban}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_swift && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>SWIFT Code:</MethodDetailsLabel>
                    <MethodDetailsValue>{bank_swift}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_account_name && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Your Full Name:</MethodDetailsLabel>
                    <MethodDetailsValue>{bank_account_name}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_street && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Street: </MethodDetailsLabel>
                    <MethodDetailsValue>{bank_street}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_city && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>City:</MethodDetailsLabel>
                    <MethodDetailsValue>{bank_city}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_zip && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>ZIP Code:</MethodDetailsLabel>
                    <MethodDetailsValue>{bank_zip}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {bank_country && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Country:</MethodDetailsLabel>
                    <MethodDetailsValue>{bank_country}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
              </MethodDetails>
              <SettingsItemButtonWrap style={{ alignSelf: "flex-start" }}>
                <ButtonPrimarySmall onClick={methodDetailsFormToggle}>
                  {methodDetailsForm ? "Close" : "Update Payment Details"}
                </ButtonPrimarySmall>
              </SettingsItemButtonWrap>
            </SettingsItemLine>
            {methodDetailsForm && (
              <MethodDetailsHidingBox>
                <InputWithLabel label="Bank Account #" width="290px">
                  <InputText
                    type="text"
                    name="bankAccountNumber"
                    value={methodDetails.bankAccountNumber}
                    placeholder="Enter bank account number"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("bankAccountNumber")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Routing #" width="200px">
                  <InputText
                    type="text"
                    name="bankRoutingNumber"
                    value={methodDetails.bankRoutingNumber}
                    placeholder="Enter routing number"
                    onChange={handleDetailsInputChange}
                    maxLength={30}
                    warning={warnings.includes("bankRoutingNumber")}
                  />
                </InputWithLabel>
                <InputWithLabel label="IBAN" width="290px">
                  <InputText
                    type="text"
                    name="bankIban"
                    value={methodDetails.bankIban}
                    placeholder="Enter IBAN"
                    onChange={handleDetailsInputChange}
                    maxLength={50}
                    warning={warnings.includes("bankIban")}
                  />
                </InputWithLabel>
                <InputWithLabel label="SWIFT Code" width="200px">
                  <InputText
                    type="text"
                    name="bankSwift"
                    value={methodDetails.bankSwift}
                    placeholder="Enter SWIFT code"
                    onChange={handleDetailsInputChange}
                    maxLength={20}
                    warning={warnings.includes("bankSwift")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Your Full Name" width="290px">
                  <InputText
                    type="text"
                    name="bankAccountName"
                    value={methodDetails.bankAccountName}
                    placeholder="Account holder's name"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("bankAccountName")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Street" width="290px">
                  <InputText
                    type="text"
                    name="bankAccountStreet"
                    value={methodDetails.bankAccountStreet}
                    placeholder="Account holder's street"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("bankAccountStreet")}
                  />
                </InputWithLabel>
                <InputWithLabel label="City" width="200px">
                  <InputText
                    type="text"
                    name="bankAccountCity"
                    value={methodDetails.bankAccountCity}
                    placeholder="Account holder's city"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("bankAccountCity")}
                  />
                </InputWithLabel>
                <InputWithLabel label="ZIP Code" width="200px">
                  <InputText
                    type="text"
                    name="bankAccountZip"
                    value={methodDetails.bankAccountZip}
                    placeholder="Account holder's ZIP code"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("bankAccountZip")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Country" width="290px">
                  <CountryDropdownSelection
                    position="top"
                    onCountrySelect={handleBankAccountCountryChange}
                    selectedCountry={methodDetails.bankAccountCountry}
                    warning={warnings.includes("bankAccountCountry")}
                    placeholder="Account holder's Country"
                  />
                </InputWithLabel>
                <WarningBox>
                  <WarningBoxIcon>
                    <img src={warningIcon} style={{ width: "100%" }} />
                  </WarningBoxIcon>
                  <WarningBoxText>
                    <WarningBoxTextParagraph>
                      Please make sure that the information you entered is
                      correct. For regulatory reasons, we may require address
                      verification before sending your payout.
                    </WarningBoxTextParagraph>
                    <WarningBoxTextParagraph>
                      If your information turns out to be incorrect, you may
                      lose your earnings.
                    </WarningBoxTextParagraph>
                  </WarningBoxText>
                </WarningBox>
                {verificationCodeRequested && (
                  <VerificationCodeInfo>
                    We have sent a verification code to your email. To save your
                    payout settings, please enter the code into the field below.
                  </VerificationCodeInfo>
                )}
                {verificationCodeRequested && (
                  <InputWithLabel label="Verification Code" width="280px">
                    <InputWithButton>
                      <InputText
                        type="text"
                        name="verificationCode"
                        value={verificationCode}
                        placeholder="Verification Code"
                        onChange={handleVerificationCodeChange}
                        maxLength={8}
                        warning={warnings.includes("verificationCode")}
                      />
                      <ButtonPrimarySmall
                        onClick={getVerificationCode}
                        disabled={verificationCodeSentCounter > 0}
                      >
                        {resendButtonText}
                      </ButtonPrimarySmall>
                    </InputWithButton>
                  </InputWithLabel>
                )}
                {verificationCodeError && (
                  <VerificationCodeError>
                    The verification code is incorrect.
                  </VerificationCodeError>
                )}
                <ButtonWrap>
                  {!verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={getVerificationCode}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Next
                    </ButtonPrimary>
                  )}
                  {verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={updateMethodDetails}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Save
                    </ButtonPrimary>
                  )}
                </ButtonWrap>
              </MethodDetailsHidingBox>
            )}
          </PaymentMethodDetails>
        </RollingBox>
      )}
      {payment_method === "skrill" && (
        <RollingBox>
          <PaymentMethodDetails>
            <SettinsgItemTitle>Skrill Details</SettinsgItemTitle>
            <SettingsItemLine>
              <MethodDetails>
                {!skrill_email && (
                  <MethodDetailsValue>
                    Skrill details not provided
                  </MethodDetailsValue>
                )}
                {skrill_email && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>
                      Skrill email address:
                    </MethodDetailsLabel>
                    <MethodDetailsValue>{skrill_email}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_full_name && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Your Full Name:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_full_name}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_street && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Street: </MethodDetailsLabel>
                    <MethodDetailsValue>{account_street}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_city && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>City:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_city}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_zip && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>ZIP Code:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_zip}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_country && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Country:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_country}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
              </MethodDetails>
              <SettingsItemButtonWrap style={{ alignSelf: "flex-start" }}>
                <ButtonPrimarySmall onClick={methodDetailsFormToggle}>
                  {methodDetailsForm ? "Close" : "Update Payment Details"}
                </ButtonPrimarySmall>
              </SettingsItemButtonWrap>
            </SettingsItemLine>
            {methodDetailsForm && (
              <MethodDetailsHidingBox>
                <InputWithLabel label="Skrill Email Address" width="290px">
                  <InputText
                    type="text"
                    name="skrillEmail"
                    value={methodDetails.skrillEmail}
                    placeholder="Enter your Skrill account email"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("skrillEmail")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Your Full Name" width="290px">
                  <InputText
                    type="text"
                    name="accountFullName"
                    value={methodDetails.accountFullName}
                    placeholder="Enter your full name"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountFullName")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Street" width="290px">
                  <InputText
                    type="text"
                    name="accountStreet"
                    value={methodDetails.accountStreet}
                    placeholder="Street and house number"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountStreet")}
                  />
                </InputWithLabel>
                <InputWithLabel label="City" width="200px">
                  <InputText
                    type="text"
                    name="accountCity"
                    value={methodDetails.accountCity}
                    placeholder="City"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountCity")}
                  />
                </InputWithLabel>
                <InputWithLabel label="ZIP Code" width="200px">
                  <InputText
                    type="text"
                    name="accountZip"
                    value={methodDetails.accountZip}
                    placeholder="ZIP code"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountZip")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Country" width="290px">
                  <CountryDropdownSelection
                    position="top"
                    onCountrySelect={handleAccountCountryChange}
                    selectedCountry={methodDetails.accountCountry}
                    warning={warnings.includes("accountCountry")}
                    placeholder="Country"
                  />
                </InputWithLabel>
                <ButtonWrap>
                  <ButtonPrimary
                    onClick={updateMethodDetails}
                    disabled={loadingUpdateMethodDetails}
                  >
                    Save
                  </ButtonPrimary>
                </ButtonWrap>
              </MethodDetailsHidingBox>
            )}
          </PaymentMethodDetails>
        </RollingBox>
      )}
      {payment_method === "bitcoin" && (
        <RollingBox>
          <PaymentMethodDetails>
            <SettinsgItemTitle>Bitcoin Details</SettinsgItemTitle>
            <SettingsItemLine>
              <MethodDetails>
                {!bitcoin_address && (
                  <MethodDetailsValue>
                    Bitcoin details not provided
                  </MethodDetailsValue>
                )}
                {bitcoin_address && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Bitcoin address:</MethodDetailsLabel>
                    <MethodDetailsValue>{bitcoin_address}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_full_name && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Your Full Name:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_full_name}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_street && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Street: </MethodDetailsLabel>
                    <MethodDetailsValue>{account_street}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_city && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>City:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_city}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_zip && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>ZIP Code:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_zip}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_country && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Country:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_country}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
              </MethodDetails>
              <SettingsItemButtonWrap style={{ alignSelf: "flex-start" }}>
                <ButtonPrimarySmall onClick={methodDetailsFormToggle}>
                  {methodDetailsForm ? "Close" : "Update Payment Details"}
                </ButtonPrimarySmall>
              </SettingsItemButtonWrap>
            </SettingsItemLine>
            {methodDetailsForm && (
              <MethodDetailsHidingBox>
                <InputWithLabel label="Bitcoin Address" width="290px">
                  <InputText
                    type="text"
                    name="bitcoinAddress"
                    value={methodDetails.bitcoinAddress}
                    placeholder="Enter your Bitcoin address"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("bitcoinAddress")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Your Full Name" width="290px">
                  <InputText
                    type="text"
                    name="accountFullName"
                    value={methodDetails.accountFullName}
                    placeholder="Enter your full name"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountFullName")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Street" width="290px">
                  <InputText
                    type="text"
                    name="accountStreet"
                    value={methodDetails.accountStreet}
                    placeholder="Street and house number"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountStreet")}
                  />
                </InputWithLabel>
                <InputWithLabel label="City" width="200px">
                  <InputText
                    type="text"
                    name="accountCity"
                    value={methodDetails.accountCity}
                    placeholder="City"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountCity")}
                  />
                </InputWithLabel>
                <InputWithLabel label="ZIP Code" width="200px">
                  <InputText
                    type="text"
                    name="accountZip"
                    value={methodDetails.accountZip}
                    placeholder="ZIP code"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountZip")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Country" width="290px">
                  <CountryDropdownSelection
                    position="top"
                    onCountrySelect={handleAccountCountryChange}
                    selectedCountry={methodDetails.accountCountry}
                    warning={warnings.includes("accountCountry")}
                    placeholder="Country"
                  />
                </InputWithLabel>
                <WarningBox>
                  <WarningBoxIcon>
                    <img src={warningIcon} style={{ width: "100%" }} />
                  </WarningBoxIcon>
                  <WarningBoxText>
                    <WarningBoxTextParagraph>
                      Please make sure that the information you entered is
                      correct. For regulatory reasons, we may require address
                      verification before sending your payout.
                    </WarningBoxTextParagraph>
                    <WarningBoxTextParagraph>
                      If your information turns out to be incorrect, you may
                      lose your earnings.
                    </WarningBoxTextParagraph>
                  </WarningBoxText>
                </WarningBox>
                {verificationCodeRequested && (
                  <VerificationCodeInfo>
                    We have sent a verification code to your email. To save your
                    payout settings, please enter the code into the field below.
                  </VerificationCodeInfo>
                )}
                {verificationCodeRequested && (
                  <InputWithLabel label="Verification Code" width="280px">
                    <InputWithButton>
                      <InputText
                        type="text"
                        name="verificationCode"
                        value={verificationCode}
                        placeholder="Verification Code"
                        onChange={handleVerificationCodeChange}
                        maxLength={8}
                        warning={warnings.includes("verificationCode")}
                      />
                      <ButtonPrimarySmall
                        onClick={getVerificationCode}
                        disabled={verificationCodeSentCounter > 0}
                      >
                        {resendButtonText}
                      </ButtonPrimarySmall>
                    </InputWithButton>
                  </InputWithLabel>
                )}
                {verificationCodeError && (
                  <VerificationCodeError>
                    The verification code is incorrect.
                  </VerificationCodeError>
                )}
                <ButtonWrap>
                  {!verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={getVerificationCode}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Next
                    </ButtonPrimary>
                  )}
                  {verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={updateMethodDetails}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Save
                    </ButtonPrimary>
                  )}
                </ButtonWrap>
              </MethodDetailsHidingBox>
            )}
          </PaymentMethodDetails>
        </RollingBox>
      )}
      {payment_method === "usdt" && (
        <RollingBox>
          <PaymentMethodDetails>
            <SettinsgItemTitle>USDT Details</SettinsgItemTitle>
            <SettingsItemLine>
              <MethodDetails>
                {!usdt_address && (
                  <MethodDetailsValue>
                    USDT details not provided
                  </MethodDetailsValue>
                )}
                {usdt_address && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>USDT address:</MethodDetailsLabel>
                    <MethodDetailsValue>{usdt_address}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {usdt_address && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Network:</MethodDetailsLabel>
                    <MethodDetailsValue>
                      {usdtNetworkOptions[usdt_network].name}
                    </MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_full_name && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Your Full Name:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_full_name}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_street && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Street: </MethodDetailsLabel>
                    <MethodDetailsValue>{account_street}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_city && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>City:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_city}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_zip && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>ZIP Code:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_zip}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_country && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Country:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_country}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
              </MethodDetails>
              <SettingsItemButtonWrap style={{ alignSelf: "flex-start" }}>
                <ButtonPrimarySmall onClick={methodDetailsFormToggle}>
                  {methodDetailsForm ? "Close" : "Update Payment Details"}
                </ButtonPrimarySmall>
              </SettingsItemButtonWrap>
            </SettingsItemLine>
            {methodDetailsForm && (
              <MethodDetailsHidingBox>
                <InputWithLabel label="USDT Address" width="290px">
                  <InputText
                    type="text"
                    name="usdtAddress"
                    value={methodDetails.usdtAddress}
                    placeholder="Enter your USDT address"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("usdtAddress")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Network" width="290px">
                  <DropdownWrap>
                    <Dropdown
                      onClick={toggleUsdtNetworkSelection}
                      dropdownRef={usdtNetworkDropdownRef}
                      warning={warnings.includes("usdtNetwork")}
                    >
                      {!methodDetails.usdtNetwork && "Select network"}
                      {methodDetails.usdtNetwork && (
                        <MethodSelectionItem>
                          <MethodSelectionIcon>
                            <img
                              src={
                                usdtNetworkOptions[methodDetails.usdtNetwork]
                                  .icon
                              }
                              alt={
                                usdtNetworkOptions[methodDetails.usdtNetwork]
                                  .name
                              }
                              style={{ width: "100%", maxHeight: "100%" }}
                            />
                          </MethodSelectionIcon>
                          <MethodSelectionText>
                            {usdtNetworkOptions[methodDetails.usdtNetwork].name}
                          </MethodSelectionText>
                        </MethodSelectionItem>
                      )}
                    </Dropdown>
                    {usdtNetworkSelectionOpened && (
                      <DropdownSelection
                        width="250px"
                        top="48px"
                        selectionRef={usdtNetworkSelectionRef}
                      >
                        {usdtNetworkOptionsList}
                      </DropdownSelection>
                    )}
                  </DropdownWrap>{" "}
                </InputWithLabel>
                <InputWithLabel label="Your Full Name" width="290px">
                  <InputText
                    type="text"
                    name="accountFullName"
                    value={methodDetails.accountFullName}
                    placeholder="Enter your full name"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountFullName")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Street" width="290px">
                  <InputText
                    type="text"
                    name="accountStreet"
                    value={methodDetails.accountStreet}
                    placeholder="Street and house number"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountStreet")}
                  />
                </InputWithLabel>
                <InputWithLabel label="City" width="200px">
                  <InputText
                    type="text"
                    name="accountCity"
                    value={methodDetails.accountCity}
                    placeholder="City"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountCity")}
                  />
                </InputWithLabel>
                <InputWithLabel label="ZIP Code" width="200px">
                  <InputText
                    type="text"
                    name="accountZip"
                    value={methodDetails.accountZip}
                    placeholder="ZIP code"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountZip")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Country" width="290px">
                  <CountryDropdownSelection
                    position="top"
                    onCountrySelect={handleAccountCountryChange}
                    selectedCountry={methodDetails.accountCountry}
                    warning={warnings.includes("accountCountry")}
                    placeholder="Country"
                  />
                </InputWithLabel>
                <WarningBox>
                  <WarningBoxIcon>
                    <img src={warningIcon} style={{ width: "100%" }} />
                  </WarningBoxIcon>
                  <WarningBoxText>
                    <WarningBoxTextParagraph>
                      Please make sure that the information you entered is
                      correct. For regulatory reasons, we may require address
                      verification before sending your payout.
                    </WarningBoxTextParagraph>
                    <WarningBoxTextParagraph>
                      If your information turns out to be incorrect, you may
                      lose your earnings.
                    </WarningBoxTextParagraph>
                  </WarningBoxText>
                </WarningBox>
                {verificationCodeRequested && (
                  <VerificationCodeInfo>
                    We have sent a verification code to your email. To save your
                    payout settings, please enter the code into the field below.
                  </VerificationCodeInfo>
                )}
                {verificationCodeRequested && (
                  <InputWithLabel label="Verification Code" width="280px">
                    <InputWithButton>
                      <InputText
                        type="text"
                        name="verificationCode"
                        value={verificationCode}
                        placeholder="Verification Code"
                        onChange={handleVerificationCodeChange}
                        maxLength={8}
                        warning={warnings.includes("verificationCode")}
                      />
                      <ButtonPrimarySmall
                        onClick={getVerificationCode}
                        disabled={verificationCodeSentCounter > 0}
                      >
                        {resendButtonText}
                      </ButtonPrimarySmall>
                    </InputWithButton>
                  </InputWithLabel>
                )}
                {verificationCodeError && (
                  <VerificationCodeError>
                    The verification code is incorrect.
                  </VerificationCodeError>
                )}
                <ButtonWrap>
                  {!verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={getVerificationCode}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Next
                    </ButtonPrimary>
                  )}
                  {verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={updateMethodDetails}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Save
                    </ButtonPrimary>
                  )}
                </ButtonWrap>
              </MethodDetailsHidingBox>
            )}
          </PaymentMethodDetails>
        </RollingBox>
      )}
      {payment_method === "faucetpay" && (
        <RollingBox>
          <PaymentMethodDetails>
            <SettinsgItemTitle>FaucetPay Details</SettinsgItemTitle>
            <SettingsItemLine>
              <MethodDetails>
                {!faucetpay_username && (
                  <MethodDetailsValue>
                    FaucetPay details not provided
                  </MethodDetailsValue>
                )}
                {faucetpay_username && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>FaucetPay Username:</MethodDetailsLabel>
                    <MethodDetailsValue>
                      {faucetpay_username}
                    </MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {faucetpay_currency && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Currency:</MethodDetailsLabel>
                    <MethodDetailsValue>
                      {faucetpayCurrencyOptions[faucetpay_currency]?.name}
                    </MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_full_name && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Your Full Name:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_full_name}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_street && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Street: </MethodDetailsLabel>
                    <MethodDetailsValue>{account_street}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_city && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>City:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_city}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_zip && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>ZIP Code:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_zip}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
                {account_country && (
                  <MethodDetailsItem>
                    <MethodDetailsLabel>Country:</MethodDetailsLabel>
                    <MethodDetailsValue>{account_country}</MethodDetailsValue>
                  </MethodDetailsItem>
                )}
              </MethodDetails>
              <SettingsItemButtonWrap style={{ alignSelf: "flex-start" }}>
                <ButtonPrimarySmall onClick={methodDetailsFormToggle}>
                  {methodDetailsForm ? "Close" : "Update Payment Details"}
                </ButtonPrimarySmall>
              </SettingsItemButtonWrap>
            </SettingsItemLine>
            {methodDetailsForm && (
              <MethodDetailsHidingBox>
                <InputWithLabel label="FaucetPay Username" width="290px">
                  <InputText
                    type="text"
                    name="faucetpayUsername"
                    value={methodDetails.faucetpayUsername}
                    placeholder="Enter your FaucetPay username"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("faucetpayUsername")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Currency" width="290px">
                  <DropdownWrap>
                    <Dropdown
                      onClick={toggleFaucetpayCurrencySelection}
                      dropdownRef={faucetpayCurrencyDropdownRef}
                      warning={warnings.includes("faucetpayCurrency")}
                    >
                      {!methodDetails.faucetpayCurrency && "Select currency"}
                      {methodDetails.faucetpayCurrency && (
                        <MethodSelectionItem>
                          <MethodSelectionIcon>
                            <img
                              src={
                                faucetpayCurrencyOptions[
                                  methodDetails.faucetpayCurrency
                                ]?.icon
                              }
                              alt={
                                faucetpayCurrencyOptions[
                                  methodDetails.faucetpayCurrency
                                ]?.name
                              }
                              style={{ width: "100%", maxHeight: "100%" }}
                            />
                          </MethodSelectionIcon>
                          <MethodSelectionText>
                            {
                              faucetpayCurrencyOptions[
                                methodDetails.faucetpayCurrency
                              ]?.name
                            }
                          </MethodSelectionText>
                        </MethodSelectionItem>
                      )}
                    </Dropdown>
                    {faucetpayCurrencySelectionOpened && (
                      <DropdownSelection
                        width="250px"
                        top="48px"
                        selectionRef={faucetpayCurrencySelectionRef}
                      >
                        {faucetpayCurrencyOptionsList}
                      </DropdownSelection>
                    )}
                  </DropdownWrap>
                </InputWithLabel>
                <InputWithLabel label="Your Full Name" width="290px">
                  <InputText
                    type="text"
                    name="accountFullName"
                    value={methodDetails.accountFullName}
                    placeholder="Enter your full name"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountFullName")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Street" width="290px">
                  <InputText
                    type="text"
                    name="accountStreet"
                    value={methodDetails.accountStreet}
                    placeholder="Street and house number"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountStreet")}
                  />
                </InputWithLabel>
                <InputWithLabel label="City" width="200px">
                  <InputText
                    type="text"
                    name="accountCity"
                    value={methodDetails.accountCity}
                    placeholder="City"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountCity")}
                  />
                </InputWithLabel>
                <InputWithLabel label="ZIP Code" width="200px">
                  <InputText
                    type="text"
                    name="accountZip"
                    value={methodDetails.accountZip}
                    placeholder="ZIP code"
                    onChange={handleDetailsInputChange}
                    maxLength={100}
                    warning={warnings.includes("accountZip")}
                  />
                </InputWithLabel>
                <InputWithLabel label="Country" width="290px">
                  <CountryDropdownSelection
                    position="top"
                    onCountrySelect={handleAccountCountryChange}
                    selectedCountry={methodDetails.accountCountry}
                    warning={warnings.includes("accountCountry")}
                    placeholder="Country"
                  />
                </InputWithLabel>
                <WarningBox>
                  <WarningBoxIcon>
                    <img src={warningIcon} style={{ width: "100%" }} />
                  </WarningBoxIcon>
                  <WarningBoxText>
                    <WarningBoxTextParagraph>
                      Please make sure that the information you entered is
                      correct. For regulatory reasons, we may require address
                      verification before sending your payout.
                    </WarningBoxTextParagraph>
                    <WarningBoxTextParagraph>
                      If your information turns out to be incorrect, you may
                      lose your earnings.
                    </WarningBoxTextParagraph>
                  </WarningBoxText>
                </WarningBox>
                {verificationCodeRequested && (
                  <VerificationCodeInfo>
                    We have sent a verification code to your email. To save your
                    payout settings, please enter the code into the field below.
                  </VerificationCodeInfo>
                )}
                {verificationCodeRequested && (
                  <InputWithLabel label="Verification Code" width="280px">
                    <InputWithButton>
                      <InputText
                        type="text"
                        name="verificationCode"
                        value={verificationCode}
                        placeholder="Verification Code"
                        onChange={handleVerificationCodeChange}
                        maxLength={8}
                        warning={warnings.includes("verificationCode")}
                      />
                      <ButtonPrimarySmall
                        onClick={getVerificationCode}
                        disabled={verificationCodeSentCounter > 0}
                      >
                        {resendButtonText}
                      </ButtonPrimarySmall>
                    </InputWithButton>
                  </InputWithLabel>
                )}
                {verificationCodeError && (
                  <VerificationCodeError>
                    The verification code is incorrect.
                  </VerificationCodeError>
                )}
                <ButtonWrap>
                  {!verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={getVerificationCode}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Next
                    </ButtonPrimary>
                  )}
                  {verificationCodeRequested && (
                    <ButtonPrimary
                      onClick={updateMethodDetails}
                      disabled={loadingUpdateMethodDetails}
                    >
                      Save
                    </ButtonPrimary>
                  )}
                </ButtonWrap>
              </MethodDetailsHidingBox>
            )}
          </PaymentMethodDetails>
        </RollingBox>
      )}
    </PayoutSettings>
  );
};
